import { DOCS_MESSAGES } from "../../pages/docs/config/docConstants";
import pageStyles from "../../styles/docs/docsPage.module.scss";

const DocsUnavailable = () => (
  <div className={pageStyles.notFound}>
    <p>{DOCS_MESSAGES.noContentAvailable}</p>
  </div>
);

export default DocsUnavailable;
